
let contentBg = promokit.video({
    el: '.p-sec3__bg',
    url: 'https://vod.plaync.com/BS/update/201211/new_BG.mp4',
    preload: true,
    mute: true,
    loop: true
});

export default {
    id: '#section-3',
    name: '소환사 신규 각성',
    backgroundVideo: contentBg,
    enterStart() {


    },
    leaveStart() {

    }
};


// WEBPACK FOOTER //
// ./src/js/pc/section3.js